module.exports = __webpack_public_path__ + "img/cacao.770d212d.jpeg";